import { render, staticRenderFns } from "./aroststatus.vue?vue&type=template&id=27d354fb"
import script from "./aroststatus.vue?vue&type=script&lang=js"
export * from "./aroststatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports